var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAvatarBlack = function SvgAvatarBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.776 22.75c0-1.29.084-2.526-.694-3.437-.778-.912-1.833-1.424-2.932-1.424H9.856c-1.1 0-2.155.512-2.933 1.424-.777.911-.698 2.148-.698 3.437M14 14a3.889 3.889 0 100-7.778A3.889 3.889 0 0014 14z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.001,
    cy: 14,
    r: 11.667,
    stroke: "#000",
    strokeWidth: 1.5
  })));
};
export default SvgAvatarBlack;